import { inject, Injectable } from '@angular/core';
import { AuthStorageService } from './auth-storage.service';
import { AuthProvider } from './authentication';
import { UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthUrlHelperService {
    private readonly authStorage = inject(AuthStorageService);

    public async getQuerySsoParams(url: UrlTree) {
        const queryAuthProvider = url.queryParamMap.get('auth_provider');
        const queryIdpHint = url.queryParamMap.get('idp_hint');
        const queryLoginHint = url.queryParamMap.get('login_hint');
        const querySkipLogin = url.queryParamMap.get('skip_login');

        let authProvider: AuthProvider | undefined;
        let idpHint: string | undefined;
        let loginHint: string | undefined;
        let skipLogin = false;

        if (queryAuthProvider && this.authStorage.isSupportedAuthProvider(queryAuthProvider)) {
            authProvider = queryAuthProvider;
            await this.authStorage.setAuthProvider(queryAuthProvider);
        }
        if (queryIdpHint) {
            idpHint = queryIdpHint;
            await this.authStorage.setIdpHint(queryIdpHint);
        }
        if (queryLoginHint) {
            loginHint = queryLoginHint;
            await this.authStorage.setLoginHint(queryLoginHint);
        }
        if (querySkipLogin) {
            skipLogin = true;
        }

        return { authProvider, idpHint, loginHint, skipLogin };
    }
}
